export default "__VITE_ASSET__GbDJZtf9__"